/**
 * Reducers
 */
const INITIAL_STATE = {
  contact: {
    selectedEmail: "",
    contactId: ""
  },
  location: "",
  stepFirstAcess: 1,
  stepForgot: 1,
  emailForgot: "",
  access_token: "",
  firstAccessToken: "",
  emailsList: [],
  phonesList: [],
  errorCredentials: false,
  registrationToken: "",
  files: {}
};


export default function accessReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case 'STEP': 
      return {
        ...state,
        stepFirstAcess: action.step
      };
    case 'STEP_FORGOT': 
      return {
        ...state,
        stepForgot: action.step
      };
    case 'SET_EMAIL_FORGOT': 
      return {
        ...state,
        emailForgot: action.email
      };
    case 'ADD_ACCESS_TOKEN':
      return {
        ...state,
        access_token: action.access_token
      };
    case 'ADD_FIRST_ACCESS_TOKEN':
      return {
        ...state,
        firstAccessToken: action.firstAccessToken
      };
    case 'ADD_FILES':
      return {
        ...state,
        files: action.files
      };
    case 'ADD_LOCATION': 
      return {
        ...state,
        location: action.location
      };
    case 'ADD_CONTACT': 
      return {
        ...state,
        contact: { 
          selectedEmail: action.email,
          contactId: action.contactId
        }
      };
    case 'ADD_EMAILSLIST': 
      return {
        ...state,
        emailsList: action.emailsList
        };
    case 'ADD_PHONELIST': 
      return {
        ...state,
        phonesList: action.phonesList
        };
    case 'SET_ERROR_CREDENTIALS':
      return {
        ...state,
        errorCredentials: action.errorCredentials
        };
    case 'SET_REGISTRATION_TOKEN':
      return {
        ...state,
        registrationToken: action.token
        };
    default:
      return state;
  }
}